import { Questionnaires } from "../enums/questionnaires";
import { Systems } from "../enums/systems";

export const CLIENT_INTAKE_IDENTIFIER = {
  system: Systems.QH,
  value: Questionnaires.ClientIntake,
};

export const INSURANCE_VERIFICATION_IDENTIFIER = {
  system: Systems.QH,
  value: Questionnaires.InsuranceBenefitsVerification,
};

export const EDU_RESOURCE_READ_STATUS_IDENTIFIER = {
  system: Systems.QH,
  value: "edu-resource-read-status",
};

export const EDU_SYSTEM_DEFAULT_FOLDER_IDENTIFIER_SYSTEM = `${Systems.QH}/fhir/identifier/edu-system-default-folder`;

export const FLAG_LIBRARY_GROUP_IDENTIFIER_SYSTEM = `${Systems.QH}/fhir/identifier/flag-library-group`;

/**
 * Mirrors a library flag's derived code onto `Flag.identifier`. R4 gives `Flag` no `code` search
 * param, so this is what an `If-None-Exist` guard can match on; the practice narrowing rides on
 * `subject` instead of on the value, so two practices may hold the same code.
 */
export const LIBRARY_FLAG_IDENTIFIER_SYSTEM = `${Systems.QH}/fhir/identifier/library-flag`;

/**
 * Mirrors the library entry's logical id onto an applied `Flag.identifier`. The extension is what
 * readers follow; this exists because an extension is not searchable, and applying a flag needs an
 * `If-None-Exist` guard so a double-submit cannot put the same flag on a chart twice.
 */
export const CLIENT_FLAG_IDENTIFIER_SYSTEM = `${Systems.QH}/fhir/identifier/client-flag`;
